<template>
    <div class="tw-px-4 tw-py-4 tw-max-w-7xl mx-auto">
        <loading-custom :loading="loading" />
        <div class="tw-w-full tw-text-xl text-center ">
            โดเมนของท่าน
            <span class="font-bold">"{{ salepageData.domain_url }}"</span>
            มีการใช้ซ้ำกับบุคคลอื่น<br />
            เพื่อยืนยันว่าท่านเป็นเจ้าของโดเมนนี้ โปรดทำตามขั้นตอนต่อไปนี้
        </div>
        <div class="instruction-container">
            <div class="instruction-page tw-w-full">
                <div class="tw-w-full tw-self-center">
                    <div class="tw-w-full tw-flex tw-justify-center">
                        <div class="instruction-step ">
                            1
                        </div>
                    </div>

                    <div class="instruction-desc">
                        ไปยังหน้าจัดการ DNS โดเมนของคุณ
                        ตามเว็บไซต์ที่คุณได้จดโดเมนไว้
                    </div>
                    <div class="tw-h-0 lg:tw-h-13"></div>
                </div>
            </div>
            <div class="instruction-page">
                <div class="tw-w-full tw-self-center">
                    <div class="tw-w-full tw-flex tw-justify-center">
                        <div class="instruction-step ">
                            2
                        </div>
                    </div>

                    <div class="instruction-desc">
                        เพิ่มค่าประเภท TXT
                        <br />และนำค่าด้านล่างนี้ใส่ในช่องมูลค่า
                           
                            <span 
                                class="tw-text-xs tw-underline tw-cursor-pointer"
                                data-toggle="modal"
                                data-target="#showExample"
                                >(ดูตัวอย่าง)</span
                            >
                    </div>
                    <div class="tw-h-5 tw-text-sm tw-text-center">
                        *หมายเหตุ ให้ใส่เครื่องหมาย @ ในช่องชื่อ
                    </div>
                    <div
                        class="tw-bg-yellow-100 tw-w-full tw-h-8 tw-mt-2 tw-rounded-md tw-border tw-border-black tw-px-4 tw-py-1 tw-flex tw-justify-between tw-items-center"
                    >
                        <div
                            id="verificationCode"
                            class="tw-w-11/12 tw-overflow-auto tw-whitespace-nowrap"
                        >
                            {{ verificationCode }}
                        </div>
                        <div
                            class="tw-flex tw-justify-end tw-items-center tw-cursor-pointer tw-self-center tw-transform tw-transition-all"
                            v-clipboard:copy="verificationCode"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                        >
                            <i
                                class="tw-absolute fa fa-clipboard tw-transition-all tw-duration-300 tw-transform"
                                :class="
                                    justCopy
                                        ? 'tw-opacity-0 tw-scale-0'
                                        : 'tw-opacity-100 tw-scale-100'
                                "
                            ></i>
                            <i
                                class="tw-absolute fa fa-check tw-transition-all tw-duration-300 tw-transform"
                                :class="
                                    justCopy
                                        ? 'tw-opacity-100 tw-scale-100'
                                        : 'tw-opacity-0 tw-scale-0'
                                "
                            ></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="instruction-page tw-w-full">
                <div class="tw-w-full tw-self-center">
                    <div class="tw-w-full tw-flex tw-justify-center">
                        <div class="instruction-step ">
                            3
                        </div>
                    </div>
                    <div class="instruction-desc">
                        รอประมาณ 1 ชั่วโมง เพื่ออัพเดท DNS
                        จากนั้นกดยืนยันที่หน้าเพจนี้
                    </div>
                    <div class="tw-h-0 lg:tw-h-13"></div>
                </div>
            </div>
        </div>

        <form>
            <div class="mt-3 tw-flex tw-justify-center">
                <button
                    type="submit"
                    class="btn btn-sm btn-success px-3 tw-text-xl tw-w-full"
                    @click.prevent="verifyDomain"
                >
                    ตกลง
                </button>
            </div>
        </form>

        <!-- Modal -->
        <div
            class="modal"
            id="showExample"
            role="dialog"
            tabindex="-1"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-light">
                        <div class="tw-text-xl tw-font-bold w-full tw-text-center tw-self-middle">
                            ตัวอย่างการตั้งค่าไฟล์ TXT ของบริการ DNS
                        </div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <i class="fa fa-times tw-text-xl"></i>
                            </span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <img class="tw-w-full" src="/images/salepage/domain_verified_example.png" alt="" />
                    </div>
                    <div class="modal-footer">
                        <div class="tw-w-full tw-flex tw-pt-3 tw-justify-center">
                            <button type="button" class="btn btn-outline-dark btn-sm" data-dismiss="modal">ปิด</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["shop", "salepage", "verificationCode"],

    data() {
        return {
            loading: false,
            justCopy: false,
            salepageData: JSON.parse(this.salepage),
            form: {
                key: ""
            }
        };
    },
    methods: {
        verifyDomain() {
            this.loading = true;
            axios
                .post(
                    `/backend/s/${this.shop}/salepages/${this.salepageData.id}/domain-verification`,
                    this.form
                )
                .then(res => {
                    this.loading = false;

                    if (res.data.status == "success") {
                        this.$swal({
                            icon: "success",
                            title: res.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                        setTimeout(() => {
                            window.location.href = `/backend/s/${this.shop}/salepages`;
                        }, 1500);
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$swal({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: err.response.data.message,
                        showConfirmButton: true
                    });
                });
        },
        onCopy: function(e) {
            this.justCopy = true;
            this.copiedText = e.text;

            setTimeout(() => {
                this.justCopy = false;
            }, 2500);
        },
        onError: function(e) {
            console.log("Failed to copy texts");
        }
    }
};
</script>
<style scoped>
.instruction-container {
    @apply tw-w-full tw-my-4 tw-p-4 tw-rounded-lg tw-grid tw-items-center;
    border: 1px solid var(--primary-color);
}

@media screen and (max-width: 768px) {
    .instruction-container {
        @apply tw-grid-cols-1 tw-gap-7;

        aspect-ratio: 7/9;
    }
}
@media screen and (min-width: 769px) {
    .instruction-container {
        @apply tw-grid-cols-3 tw-gap-10;
        aspect-ratio: 16/5;
    }
}

.instruction-page {
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
}
.instruction-step {
    @apply tw-rounded-full tw-w-10 tw-h-10 tw-flex tw-justify-center tw-items-center tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-font-bold tw-mx-auto tw-mb-2;
    background-color: var(--primary-color);
}

.instruction-icon {
    @apply tw-w-full tw-justify-center tw-hidden lg:tw-flex tw-mt-6 tw-mb-4;
    color: var(--primary-color);
}
.instruction-desc {
    @apply tw-self-center tw-text-lg lg:tw-text-xl tw-text-gray-600 tw-text-center;
}

</style>
